import React, { createContext, useContext, useEffect, useState } from 'react'
import translations from '../translation/translation.json'

const TranslationContext = createContext()

const LOCALE_KEY = 'walaa_locale'

export function TranslationProvider({ children }) {
  const [locale, setLocaleState] = useState(
    () => localStorage.getItem(LOCALE_KEY) || 'en'
  )

  const setLocale = (lang) => {
    localStorage.setItem(LOCALE_KEY, lang)
    setLocaleState(lang)
  }

  useEffect(() => {
    const isRTL = locale === 'ar'
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.documentElement.lang = locale
  }, [locale])

  const t = (key) => translations[locale]?.[key] ?? translations['en']?.[key] ?? key

  return (
    <TranslationContext.Provider value={{ locale, setLocale, t, isRTL: locale === 'ar' }}>
      {children}
    </TranslationContext.Provider>
  )
}

export function useTranslation() {
  return useContext(TranslationContext)
}
